// Konstanta & util form konfigurasi notifikasi (topic/template/contact/subscription). Murni.
import { SEVERITY_META, CATEGORY_META } from './notificationInbox.js';

const toOptions = (pairs) => pairs.map(([value, text]) => ({ value, text }));
// label ambil dari META, urutan tampil tetap ditulis lokal
const optionsFromMeta = (meta, order) => order.map((key) => ({ value: key, text: meta[key].label }));

export const CATEGORY_OPTIONS = optionsFromMeta(
  CATEGORY_META,
  ['ALERT', 'EVENT', 'REPORT', 'ASSET', 'SUMMARY', 'SYSTEM'],
);

export const SEVERITY_OPTIONS = optionsFromMeta(SEVERITY_META, ['INFO', 'WARNING', 'CRITICAL']);

export const PHASE_OPTIONS = toOptions([
  ['START', 'Start'], ['REMINDER', 'Reminder'], ['RESOLVE', 'Resolve'], ['SINGLE', 'Single'],
]);

const PHASE_DESCRIPTION_TEXT = {
  START: 'Sent when an incident begins, for example when a device stops sending data.',
  REMINDER: 'Sent again while the incident is still ongoing.',
  RESOLVE: 'Sent when the incident is over, for example when the device is back online.',
  SINGLE: 'For one-off notifications with no start or end, such as a report being ready. '
    + 'Also used as the fallback message when a topic has no template for a phase.',
};

// label ikut PHASE_OPTIONS, jangan ditulis dua kali
export const PHASE_DESCRIPTIONS = PHASE_OPTIONS.map((option) => ({
  ...option,
  description: PHASE_DESCRIPTION_TEXT[option.value],
}));

export const CHANNEL_OPTIONS = toOptions([
  ['inapp', 'In-app'], ['email', 'Email'], ['push', 'Push'],
  ['whatsapp', 'WhatsApp'], ['webhook', 'Webhook'],
]);

export const TOPIC_CHANNEL_OPTIONS = CHANNEL_OPTIONS.filter(
  (option) => ['inapp', 'email', 'push'].includes(option.value),
);

export const AUDIENCE_SCOPE_OPTIONS = toOptions([['any', 'Any'], ['internal', 'Internal only']]);
export const SCOPE_TYPE_OPTIONS = toOptions([['GLOBAL', 'Global'], ['COMPANY', 'Company'], ['ASSET', 'Asset']]);
export const AUDIENCE_TYPE_OPTIONS = toOptions([
  ['USER', 'User'], ['CONTACT', 'Contact'], ['MEMBERS', 'Company members'],
]);
export const STATUS_OPTIONS = toOptions([[1, 'Active'], [0, 'Inactive']]);

// dipakai di form select topic (template & subscription) — tetap lokal, gak ada searchField
export const TOPIC_SOURCE = { master: 'notification/topic', keyField: 'ntopId', displayField: 'ntopName' };

// dipakai di subscription & preview modal — punya searchField, jadi nyari ke backend
export const ASSET_SOURCE = {
  master: 'asset', keyField: 'massId', displayField: 'massName', searchField: 'massName',
};
export const USER_SOURCE = {
  master: 'user', keyField: 'userId', displayField: 'userId', searchField: 'userId',
};

// kolom badge Active/Inactive, dipakai topic/contact/subscription
export function statusColumn(key, label) {
  return {
    key,
    label,
    type: 'badge',
    variant: (row) => (Number(row[key]) === 1 ? 'success' : 'secondary'),
    formatter: (value) => (Number(value) === 1 ? 'Active' : 'Inactive'),
  };
}

const CHANNEL_ICONS = {
  inapp: 'ri-notification-3-line',
  email: 'ri-mail-line',
  push: 'ri-smartphone-line',
  whatsapp: 'ri-whatsapp-line',
  webhook: 'ri-link',
};

export function channelIcon(channel) {
  return CHANNEL_ICONS[channel] || 'ri-radio-button-line';
}

// SEVERITY_META gak nyimpen nama varian Bootstrap, jadi dipetakan sekali di sini
const SEVERITY_VARIANT = {
  CRITICAL: 'danger',
  WARNING: 'warning',
  INFO: 'primary',
};

export function severityVariant(severity) {
  const known = Object.prototype.hasOwnProperty.call(SEVERITY_VARIANT, severity);
  return known ? SEVERITY_VARIANT[severity] : 'secondary';
}

export function topicCodeById(topics, id) {
  const rows = Array.isArray(topics) ? topics : [];
  const hit = rows.find((row) => String(row.ntopId) === String(id));
  return hit ? hit.ntopCode : '';
}

// Preview endpoint: 404 topic gak dikenal, 412 asset di luar akses.
export function previewErrorMessage(errorCode, fallback) {
  if (Number(errorCode) === 404) return 'Topic not found.';
  if (Number(errorCode) === 412) return 'This asset is outside your access.';
  return fallback || 'Preview failed.';
}

// targetType kosong pas edit, jadi disimpulin dari ntsbCategory
export function isCategoryTarget(form) {
  const state = form || {};
  return state.targetType === 'category' || (!state.targetType && !!state.ntsbCategory);
}

export function previewParams(form) {
  const source = form || {};
  const params = {};
  ['ntopCode', 'compId', 'massId', 'phase', 'severity'].forEach((key) => {
    const value = source[key];
    if (value === '' || value === null || value === undefined) return;
    params[key] = value;
  });
  return params;
}

// relasi kosong datang sebagai array, bukan null
export function relationOf(raw) {
  if (!raw || Array.isArray(raw)) return null;
  return typeof raw === 'object' ? raw : null;
}
